import { useEffect, useRef, useState } from 'react';
import Tabs from '../../tabs/tabs';
import TransactionStatusChange from '../incoming-outgoing-transaction-status-change';
import {
  OutgoingTransactionGeneral,
  OutgoingTransactionOrder,
  EnumTabs,
  BaseellaStatus,
  TransactionTypeEnum,
} from '../types';
import OutgoingGeneralContent from './outgoing-transaction-general';
import OutgoingOrderContent from './outgoing-transaction-order';
import IncomingOutgoingAmlContent from '../incoming-outgoing-transaction-aml';
import TransactionLogsContent from '../transaction-logs-content';
import TransactionWarnings from '../warnings/transation-warning';
import ChangeLogs from '../../change-logs/change-logs';
import TransactionSignatures from '../signatures/signatures';
import TransactionDocuments from '../documents/documents';
import TransactionAccountingEntries from '../accounting-entries/accounting-entries';
import TransactionChats from '../chats/chats';
import TransactionComments from '../comments/comments';
import IconAttention from '../../icons/attention';
import ButtonPrimary from '../../button/button-primary';
import ButtonSecondary from '../../button/button-secondary';
import { PermissionEnum } from '../../../base-types';
import formatDate from '../../../helpers/format-date';
import { OutgoingTransactionSidepanelContentFormTypes } from './types';
import IntegrationLogs from '../integration-logs/list';
import PermissionDenied from '../../permission-denied/permission-denied';
import CreationDisabledInfo from '../disable-creation-option/creation-disabled-info';

import styles from '../transaction.module.css';

export default function OutgoingTransactionSidepanelContentForm({
  statusesInfo,
  onRollbackStatus,
  onNextStatus,
  control,
  transactionInfo,
  amlInfo,
  currencies,
  senderAccounts,
  pspPartnerAccounts,
  paymentsTypes,
  chargeTypes,
  countries,
  beneficiaryTypes,
  isCreateForm,
  isEditable,
  errors,
  onSearchAutocomplete,
  balanceIsLoading,
  pspPartnersIsLoading,
  senderAccountsIsLoading,
  pspPartnerAccountsIsLoading,
  pspPartnerIsFilled,
  paymentTypeIsFilled,
  pspPartners,
  baseellaStatus,
  logs,
  onScrollToPaymentType,
  paymentType,
  feeText,
  warnings,
  employee,
  changeLogs,
  accountBalance,
  onApplyTransactionAction,
  currencyId,
  updateBalance,
  updatePspPartnerBalance,
  pspPartnerAccountBalance,
  pspPartnerBalanceIsLoading,
  signatures,
  sendCode,
  sendCodeInProgress,
  transactionsTypes,
  setRejectPopupVisible,
  setBlacklistDataVisible,
  setBlacklistData,
  setBlacklistItemVisible,
  setBlacklistDataItem,
  parentRef,
  parentScroll = 0,
  updateStatusIsLoading,
  isLoadingStatuses,
  activePermission,
  amount,
  setAmount,
  latestQueuedStatus,
  createdByOrganizationId,
  applyTransactionsWarningIsLoading,
  companyOfficials,
  chats,
  onCreateTransactionChat,
  chatCreateInProgress,
  currentEmployee,
  createChatWithMessage,
  documents,
  setSubPanelVisible,
  setSelectedDocumentName,
  setTransactionSidepanelVisible,
  onUploadDocument,
  uploadDocumentInProgress,
  uploadDocumentIsSuccess,
  uploadDocumentErrors,
  selectedDocumentId,
  setSelectedDocumentId,
  downloadInProgress,
  activeTab,
  setActiveTab,
  tabs,
  glTransactionsIsLoading,
  glTransactions,
  setGlTransactionSidePanelVisible,
  onGlTransactionClick,
  onDownloadDocument,
  getTransactionDocument,
  canSignTransaction,
  balances,
  accountBalancesIsLoading,
  currenciesList,
  duplicate,
  fields,
  caspList,
  getTransactionDocuments,
  documentsIsLoading,
  getGeneralLedgerTransactionValues,
  getTransactionsChats,
  transactionChatsIsLoading,
  getCompanyOfficials,
  getSignaturesTransactionById,
  isLoadingSignatures,
  getOutgoingTransactionByIdAml,
  isLoadingAml,
  getLogsTransactionById,
  isLoadingLogs,
  overdraftEnabled,
  senderAccountsWithInfo,
  pspPartnersAccountsList,
  pspPartnerAccountBalanceInfo,
  getTransactionChangeLogs,
  changeLogsIsLoading,
  users,
  transactionChangeLogsPagination,
  changeLogsIsFetching,
  transactionId,
  onResetTransactionWarningAction,
  resetTransactionsWarningIsLoading,
  resetTransactionsWarningIsSuccess,
  documentsPagination,
  documentsIsFetching,
  attachedDocumentsErrors,
  uploadedDocumentsErrors,
  transactionComments,
  transactionCommentsPagination,
  getTransactionCommentsAction,
  commentsIsLoading,
  commentsIsFetching,
  onAddCommentToTransaction,
  addCommentInProgress,
  addCommentIsSuccess,
  onEditCommentInTransaction,
  editTransactionCommentInProgress,
  editTrancastionCommentIsSuccess,
  onDeleteCommentInTransaction,
  deleteCommentInTransactionInProgress,
  deleteCommentInTranscationIsSuccess,
  getOutgoingTransactionWarningById,
  isWarningByIdFetching,
  isWarningByIdLoading,
  warningsInfo,
  ibanValidationAvailable,
  onValidateIban,
  ibanValidationValues,
  ibanValidationIsLoading,
  setValue,
  bicSearchAvailable,
  bicValidationAvailable,
  onSearchBic,
  onBicValidate,
  bicSearchIsLoading,
  beneficairyBicSearchResults,
  intermediaryBicSearchResults,
  selectedValidationType,
  bicValidationIntermediaryResult,
  bicValidationBeneficiaryResult,
  bicValidationIsLoading,
  countriesList,
  setChangedPaymentType,
  setChangedPaymentTypeHintVisible,
  setBicValidationBeneficiaryResult,
  setError,
  clearErrors,
  setIbanValidationValues,
  selectedWarningId,
  getIntegrationLogs,
  integrationLogsIsLoading,
  integrationLogsIsFetching,
  integrationLogs,
  integrationLogsPagination,
  pspPartnerAccountsNextPageIsLoading,
  pspPartnerAccountsOnScroll,
  pspPartnerAccountsPagination,
  externalAccounts,
  externalAccountsIsLoading,
  updateExternalBalance,
  onSearchExternalAccounts,
  onClearExternalAccounts,
  onGetExternalAccountsListAction,
  externalAccountsPagination,
  externalAccountsNextPageIsLoading,
  purposeCodeVisible,
  purposeCodes,
  purposeCodesIsLoading,
  purposeCodesNextPageIsLoading,
  onScrollPurposeCodes,
  purposeCodesPagination,
  warningActionError,
  withTime,
  setWithTime,
}: OutgoingTransactionSidepanelContentFormTypes): React.JSX.Element {
  const scrollRef = useRef<HTMLDivElement | null>(null);
  const [isChangedTab, setIsChangedTab] = useState<boolean>(false);

  const scrollToPaymentTypeField = () => {
    setActiveTab(EnumTabs.GENERAL);
    if (onScrollToPaymentType) {
      onScrollToPaymentType();
    }
  };

  useEffect(() => {
    if (
      !isChangedTab &&
      activeTab !== EnumTabs.DOCUMENTS &&
      activeTab !== EnumTabs.GL_TRANSACTIONS
    ) {
      setIsChangedTab(true);

      if (warningsInfo && warningsInfo.entitySummary.unprocessed > 0) {
        setActiveTab(EnumTabs.WARNING);
      } else {
        setActiveTab(EnumTabs.GENERAL);
      }
    }
  }, [warningsInfo, isChangedTab]);

  useEffect(() => {
    if (duplicate) {
      setActiveTab(EnumTabs.GENERAL);
    }
  }, [duplicate]);

  useEffect(() => {
    if (activeTab === EnumTabs.DOCUMENTS && getTransactionDocuments) {
      getTransactionDocuments();
    }

    if (
      activeTab === EnumTabs.GL_TRANSACTIONS &&
      getGeneralLedgerTransactionValues
    ) {
      getGeneralLedgerTransactionValues();
    }

    if (
      activeTab === EnumTabs.CHANGE_LOG &&
      getTransactionChangeLogs &&
      activePermission?.includes(PermissionEnum.AUDIT_LOG_LIST)
    ) {
      getTransactionChangeLogs();
    }

    if (
      (activeTab === EnumTabs.CHATS || activeTab === EnumTabs.WARNING) &&
      getTransactionsChats &&
      activePermission?.includes(PermissionEnum.CHANNELS_LIST)
    ) {
      getTransactionsChats();

      if (
        transactionInfo &&
        transactionInfo.senderAccount &&
        transactionInfo.senderAccount?.organization?.type === 'CORPORATE' &&
        getCompanyOfficials
      ) {
        getCompanyOfficials(transactionInfo.senderAccount.organizationId);
      }
    }

    if (activeTab === EnumTabs.SIGNATURES && getSignaturesTransactionById) {
      getSignaturesTransactionById();
    }

    if (activeTab === EnumTabs.AML && getOutgoingTransactionByIdAml) {
      getOutgoingTransactionByIdAml();
    }

    if (
      activeTab === EnumTabs.LOG &&
      getLogsTransactionById &&
      activePermission?.includes(
        PermissionEnum.TRANSACTION_QUEUE_ITEMS_OUTGOING_LIST,
      )
    ) {
      getLogsTransactionById();
    }
    if (
      activeTab === EnumTabs.COMMENTS &&
      getTransactionCommentsAction &&
      activePermission?.includes(
        PermissionEnum.TRANSACTIONS_OUTGOING_COMMENTS_LIST,
      )
    ) {
      getTransactionCommentsAction();
    }
  }, [activeTab, activePermission, transactionInfo]);

  return (
    <>
      {baseellaStatus === BaseellaStatus.NOT_SIGNED && canSignTransaction && (
        <div className={styles.notSignedAlert}>
          <div className={styles.notSignedText}>
            <IconAttention width={24} height={24} />
            Additional signatures required
          </div>
          <div className={styles.notSignedControls}>
            {!createdByOrganizationId && (
              <ButtonPrimary
                text={sendCodeInProgress ? 'Loading...' : 'Sign'}
                onClick={sendCode}
                className={styles.signButton}
                disabled={sendCodeInProgress}
              />
            )}
            <ButtonSecondary
              text="Reject"
              onClick={() =>
                setRejectPopupVisible && setRejectPopupVisible(true)
              }
            />
          </div>
        </div>
      )}
      {statusesInfo && !transactionInfo?.deletedAt && (
        <TransactionStatusChange
          transaction={statusesInfo}
          baseellaStatus={baseellaStatus}
          onNextStatus={onNextStatus}
          onRollbackStatus={onRollbackStatus}
          updateStatusIsLoading={updateStatusIsLoading}
          isLoadingStatuses={isLoadingStatuses}
          latestQueuedStatus={latestQueuedStatus}
          activeTab={activeTab as EnumTabs}
        />
      )}
      {transactionInfo?.deletedAt && (
        <div className={styles.deleted}>{`Transaction deleted ${formatDate(
          transactionInfo?.deletedAt,
          true,
        )}`}</div>
      )}
      <Tabs
        tabs={tabs}
        onClick={(value) => {
          setActiveTab(value as EnumTabs);

          if (parentScroll >= Number(scrollRef.current?.offsetTop) - 130) {
            parentRef?.current?.scrollTo({
              top: Number(scrollRef.current?.offsetTop) - 130,
            });
          }
        }}
        activeTab={activeTab}
        warningsCount={warningsInfo?.entitySummary.unprocessed}
        hideWarningTabs={!warningsInfo?.entitySummary.total}
        itemClassName={styles.transactionTab}
        moreButtonClassName={styles.transactionMoreButton}
        isTransactionsTabs
        // eslint-disable-next-line react-hooks/refs
        withShadow={parentScroll > Number(scrollRef.current?.offsetTop) - 130}
        withSticky
      />
      {transactionId && fields?.disableExternalTransactionCreate && (
        <CreationDisabledInfo />
      )}
      <div
        ref={scrollRef}
        className={`${
          activeTab === EnumTabs.GL_TRANSACTIONS
            ? styles.sidepanelContentWrapper
            : ''
        } ${styles.siddepanelContentFlex}`}
      >
        <div
          className={
            activeTab === EnumTabs.GENERAL
              ? styles.activeTabContent
              : styles.tabContent
          }
        >
          <OutgoingGeneralContent
            isLoading={false}
            control={control}
            general={transactionInfo as OutgoingTransactionGeneral}
            currencies={currencies}
            pspPartnerAccounts={pspPartnerAccounts}
            senderAccounts={senderAccounts}
            paymentsTypes={paymentsTypes}
            chargeTypes={chargeTypes}
            isEditable={isEditable}
            errors={errors}
            onSearchAutocomplete={onSearchAutocomplete}
            pspPartnersIsLoading={pspPartnersIsLoading}
            senderAccountsIsLoading={senderAccountsIsLoading}
            pspPartnerAccountsIsLoading={pspPartnerAccountsIsLoading}
            pspPartnerIsFilled={pspPartnerIsFilled}
            paymentTypeIsFilled={paymentTypeIsFilled}
            pspPartners={pspPartners}
            baseellaStatus={baseellaStatus}
            feeText={feeText}
            paymentType={paymentType}
            accountBalance={accountBalance}
            currencyId={currencyId}
            balanceIsLoading={balanceIsLoading}
            updateBalance={updateBalance}
            updatePspPartnerBalance={updatePspPartnerBalance}
            pspPartnerBalanceIsLoading={pspPartnerBalanceIsLoading}
            pspPartnerAccountBalance={pspPartnerAccountBalance}
            activePermission={activePermission}
            amount={amount}
            setAmount={setAmount}
            balances={balances}
            accountBalancesIsLoading={accountBalancesIsLoading}
            currenciesList={currenciesList}
            fields={fields}
            overdraftEnabled={overdraftEnabled}
            senderAccountsWithInfo={senderAccountsWithInfo}
            pspPartnersAccountsList={pspPartnersAccountsList}
            pspPartnerAccountBalanceInfo={pspPartnerAccountBalanceInfo}
            transactionId={transactionId}
            pspPartnerAccountsNextPageIsLoading={
              pspPartnerAccountsNextPageIsLoading
            }
            pspPartnerAccountsOnScroll={pspPartnerAccountsOnScroll}
            pspPartnerAccountsPagination={pspPartnerAccountsPagination}
            externalAccounts={externalAccounts}
            externalAccountsIsLoading={externalAccountsIsLoading}
            updateExternalBalance={updateExternalBalance}
            onSearchExternalAccounts={onSearchExternalAccounts}
            onClearExternalAccounts={onClearExternalAccounts}
            onGetExternalAccountsListAction={onGetExternalAccountsListAction}
            externalAccountsPagination={externalAccountsPagination}
            externalAccountsNextPageIsLoading={
              externalAccountsNextPageIsLoading
            }
            setValue={setValue}
            clearErrors={clearErrors}
            withTime={withTime}
            setWithTime={setWithTime}
          />
        </div>

        <div
          className={
            activeTab === EnumTabs.ORDER
              ? styles.activeTabContent
              : styles.tabContent
          }
        >
          <OutgoingOrderContent
            isLoading={false}
            control={control}
            order={transactionInfo as OutgoingTransactionOrder}
            countries={countries}
            beneficiaryTypes={beneficiaryTypes}
            isEditable={isEditable}
            errors={errors}
            onScrollToPaymentTypeField={scrollToPaymentTypeField}
            paymentType={paymentType}
            activePermission={activePermission}
            fields={fields}
            caspList={caspList}
            currencyId={currencyId}
            transactionId={transactionId}
            currencies={currencies}
            ibanValidationAvailable={ibanValidationAvailable}
            onValidateIban={onValidateIban}
            ibanValidationValues={ibanValidationValues}
            ibanValidationIsLoading={ibanValidationIsLoading}
            setValue={setValue}
            bicSearchAvailable={bicSearchAvailable}
            bicValidationAvailable={bicValidationAvailable}
            onSearchBic={onSearchBic}
            onBicValidate={onBicValidate}
            bicSearchIsLoading={bicSearchIsLoading}
            beneficairyBicSearchResults={beneficairyBicSearchResults}
            intermediaryBicSearchResults={intermediaryBicSearchResults}
            selectedValidationType={selectedValidationType}
            bicValidationIntermediaryResult={bicValidationIntermediaryResult}
            bicValidationBeneficiaryResult={bicValidationBeneficiaryResult}
            bicValidationIsLoading={bicValidationIsLoading}
            countriesList={countriesList}
            setChangedPaymentType={setChangedPaymentType}
            setChangedPaymentTypeHintVisible={setChangedPaymentTypeHintVisible}
            setBicValidationBeneficiaryResult={
              setBicValidationBeneficiaryResult
            }
            setError={setError}
            clearErrors={clearErrors}
            setIbanValidationValues={setIbanValidationValues}
            purposeCodeVisible={purposeCodeVisible}
            purposeCodes={purposeCodes}
            purposeCodesIsLoading={purposeCodesIsLoading}
            purposeCodesNextPageIsLoading={purposeCodesNextPageIsLoading}
            onScrollPurposeCodes={onScrollPurposeCodes}
            purposeCodesPagination={purposeCodesPagination}
            onSearchAutocomplete={onSearchAutocomplete}
          />
        </div>
        {!isCreateForm && (
          <>
            <div
              className={
                activeTab === EnumTabs.AML
                  ? styles.activeTabContent
                  : styles.tabContent
              }
            >
              <IncomingOutgoingAmlContent
                transactionType={TransactionTypeEnum.OUTGOING}
                isLoading={isLoadingAml as boolean}
                aml={amlInfo}
              />
            </div>
            <div
              className={
                activeTab === EnumTabs.WARNING
                  ? styles.activeTabContent
                  : styles.tabContent
              }
            >
              <TransactionWarnings
                warnings={warnings}
                employee={employee}
                onApplyTransactionAction={onApplyTransactionAction}
                transactionType={TransactionTypeEnum.OUTGOING}
                transactionsTypes={transactionsTypes}
                setBlacklistDataVisible={setBlacklistDataVisible}
                setBlacklistData={setBlacklistData}
                setBlacklistItemVisible={setBlacklistItemVisible}
                setBlacklistDataItem={setBlacklistDataItem}
                applyTransactionsWarningIsLoading={
                  applyTransactionsWarningIsLoading
                }
                companyOfficials={companyOfficials}
                individualCustomer={transactionInfo?.senderAccount}
                chats={chats}
                createChatWithMessage={createChatWithMessage}
                chatCreateInProgress={chatCreateInProgress}
                activePermissions={activePermission}
                onResetTransactionWarningAction={
                  onResetTransactionWarningAction
                }
                resetTransactionsWarningIsLoading={
                  resetTransactionsWarningIsLoading
                }
                resetTransactionsWarningIsSuccess={
                  resetTransactionsWarningIsSuccess
                }
                hiddenApprove={
                  !activePermission?.includes(
                    PermissionEnum.TRANSACTIONS_OUTGOING_AML_APPROVE_ACTION,
                  )
                }
                hiddenReject={
                  !activePermission?.includes(
                    PermissionEnum.TRANSACTIONS_OUTGOING_AML_REJECT_ACTION,
                  )
                }
                getWarningById={getOutgoingTransactionWarningById}
                isWarningByIdFetching={isWarningByIdFetching}
                isWarningByIdLoading={isWarningByIdLoading}
                warningsInfo={warningsInfo}
                selectedWarningId={selectedWarningId}
                warningActionError={warningActionError}
              />
            </div>
            <div
              className={
                activeTab === EnumTabs.LOG
                  ? styles.activeTabContent
                  : styles.tabContent
              }
            >
              <TransactionLogsContent
                isLoading={isLoadingLogs as boolean}
                logs={logs}
                activePermission={activePermission?.includes(
                  PermissionEnum.TRANSACTION_QUEUE_ITEMS_OUTGOING_LIST,
                )}
              />
            </div>
            <div
              className={
                activeTab === EnumTabs.CHANGE_LOG
                  ? styles.activeTabContent
                  : styles.tabContent
              }
            >
              <ChangeLogs
                entityType="TRANSACTION"
                entityId={transactionId as string}
                changeLogsIsLoading={changeLogsIsLoading}
                changeLogs={changeLogs}
                activePermission={activePermission}
                users={users}
                pagination={transactionChangeLogsPagination}
                changeLogsIsFetching={changeLogsIsFetching}
                getChangeLogs={getTransactionChangeLogs}
              />
            </div>
            <div
              className={
                activeTab === EnumTabs.DOCUMENTS
                  ? styles.activeTabContent
                  : styles.tabContent
              }
            >
              <TransactionDocuments
                documents={documents}
                setSubPanelVisible={setSubPanelVisible}
                setSelectedDocumentName={setSelectedDocumentName}
                setTransactionSidepanelVisible={setTransactionSidepanelVisible}
                onUploadDocument={onUploadDocument}
                uploadDocumentInProgress={uploadDocumentInProgress}
                uploadDocumentIsSuccess={uploadDocumentIsSuccess}
                uploadDocumentErrors={uploadDocumentErrors}
                selectedDocumentId={selectedDocumentId}
                setSelectedDocumentId={setSelectedDocumentId}
                downloadInProgress={downloadInProgress}
                onDownloadDocument={onDownloadDocument}
                getTransactionDocument={getTransactionDocument}
                activePermission={activePermission}
                documentsIsLoading={documentsIsLoading}
                documentsPagination={documentsPagination}
                getTransactionDocuments={getTransactionDocuments}
                documentsIsFetching={documentsIsFetching}
                attachedDocumentsErrors={attachedDocumentsErrors}
                uploadedDocumentsErrors={uploadedDocumentsErrors}
              />
            </div>
            <div
              className={
                activeTab === EnumTabs.SIGNATURES
                  ? styles.activeTabContent
                  : styles.tabContent
              }
            >
              <TransactionSignatures
                signatures={signatures}
                isLoadingSignatures={isLoadingSignatures}
              />
            </div>
            <div
              className={
                activeTab === EnumTabs.GL_TRANSACTIONS
                  ? styles.activeTabContent
                  : styles.tabContent
              }
            >
              <TransactionAccountingEntries
                glTransactionsIsLoading={glTransactionsIsLoading}
                glTransactions={glTransactions}
                setGlTransactionSidePanelVisible={
                  setGlTransactionSidePanelVisible
                }
                onGlTransactionClick={onGlTransactionClick}
                setTransactionSidepanelVisible={setTransactionSidepanelVisible}
                currenciesList={currenciesList}
              />
            </div>
            <div
              className={
                activeTab === EnumTabs.INTEGRATION_LOGS
                  ? styles.activeTabContent
                  : styles.tabContent
              }
            >
              {getIntegrationLogs &&
              activePermission?.includes(
                PermissionEnum.PSP_INTEGRATION_LOGS_LIST,
              ) ? (
                <IntegrationLogs
                  getIntegrationLogs={getIntegrationLogs}
                  integrationLogs={integrationLogs}
                  integrationLogsIsFetching={integrationLogsIsFetching}
                  integrationLogsIsLoading={integrationLogsIsLoading}
                  integrationLogsPagination={integrationLogsPagination}
                  activePermissions={activePermission}
                  activeTab={activeTab}
                  pspPartnerId={transactionInfo?.pspPartnerId}
                  transactionId={transactionId}
                />
              ) : (
                <>
                  <div className={styles.changeLogsTitle}>Integration log</div>
                  <PermissionDenied />
                </>
              )}
            </div>
            <div
              className={
                activeTab === EnumTabs.CHATS
                  ? styles.activeTabContent
                  : styles.tabContent
              }
            >
              <TransactionChats
                chats={chats}
                companyOfficials={companyOfficials}
                individualCustomer={transactionInfo?.senderAccount}
                onCreateTransactionChat={onCreateTransactionChat}
                chatCreateInProgress={chatCreateInProgress}
                currentEmployee={currentEmployee}
                activePermissions={activePermission}
                transactionChatsIsLoading={transactionChatsIsLoading}
              />
            </div>
            <div
              className={
                activeTab === EnumTabs.COMMENTS
                  ? styles.activeTabContent
                  : styles.tabContent
              }
            >
              <TransactionComments
                comments={transactionComments}
                pagination={transactionCommentsPagination}
                isLoading={commentsIsLoading}
                isFetching={commentsIsFetching}
                commentsAvailable={activePermission?.includes(
                  PermissionEnum.TRANSACTIONS_OUTGOING_COMMENTS_LIST,
                )}
                getCommentsList={getTransactionCommentsAction}
                createAvailable={activePermission?.includes(
                  PermissionEnum.TRANSACTIONS_OUTGOING_COMMENTS_CREATE_ACTION,
                )}
                editAvailable={activePermission?.includes(
                  PermissionEnum.TRANSACTIONS_OUTGOING_COMMENTS_EDIT_ACTION,
                )}
                deleteAvailable={activePermission?.includes(
                  PermissionEnum.TRANSACTIONS_OUTGOING_COMMENTS_DELETE_ACTION,
                )}
                onAddCommentToTransaction={onAddCommentToTransaction}
                addCommentInProgress={addCommentInProgress}
                addCommentIsSuccess={addCommentIsSuccess}
                onEditCommentInTransaction={onEditCommentInTransaction}
                editTransactionCommentInProgress={
                  editTransactionCommentInProgress
                }
                editTrancastionCommentIsSuccess={
                  editTrancastionCommentIsSuccess
                }
                onDeleteCommentInTransaction={onDeleteCommentInTransaction}
                deleteCommentInTransactionInProgress={
                  deleteCommentInTransactionInProgress
                }
                deleteCommentInTranscationIsSuccess={
                  deleteCommentInTranscationIsSuccess
                }
                changeLogsAvailable={activePermission?.includes(
                  PermissionEnum.AUDIT_LOG_LIST,
                )}
                users={users}
              />
            </div>
          </>
        )}
      </div>
    </>
  );
}
